import { IBaseDeleteRequestModel } from "../models/request/base/deleteRequest";
import { sf_hinhthucmiengiam_group } from "../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import { apiClient } from "./apiClient";

export const sf_hinhthucmiengiam_group_SELECT_ALL_API = "sf_hinhthucmiengiam_group/select";
export const sf_hinhthucmiengiam_group_INSERT_API = "sf_hinhthucmiengiam_group/insert";
export const sf_hinhthucmiengiam_group_UPDATE_API = "sf_hinhthucmiengiam_group/update";
export const sf_hinhthucmiengiam_group_DELETE_API = "sf_hinhthucmiengiam_group/delete";



export const hinhThucMienGiamGroupApi = {
    selectAll: () => {
        return apiClient.get(`${sf_hinhthucmiengiam_group_SELECT_ALL_API}`)
    },
    select: (nam_hoc: string) => {
        return apiClient.post(`${sf_hinhthucmiengiam_group_SELECT_ALL_API}`, nam_hoc)
    },
    insert: (data: sf_hinhthucmiengiam_group) => {
        return apiClient.post(`${sf_hinhthucmiengiam_group_INSERT_API}`, data)
    },
    update: (data: sf_hinhthucmiengiam_group) => {
        return apiClient.post(`${sf_hinhthucmiengiam_group_UPDATE_API}`, data)
    },
    delete: (data: number[]) => {
        const model: IBaseDeleteRequestModel = {
            ids: data
        }
        return apiClient.post(`${sf_hinhthucmiengiam_group_DELETE_API}`, model)
    }
}
